var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"77e39e1bbed01a2efb5e649d8409bf6176d8e136"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["myody-vue@kompeito"]={id:"77e39e1bbed01a2efb5e649d8409bf6176d8e136"};
      